import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { deleteBoilerPlateTandCs } from "./actions";

const RemoveBoilerPlateModal = ({
  id,
  dealerId,
  onDeleted,
  reference,
  ...props
}) => {
  return (
    <ModalBuilder
      submitAction={deleteBoilerPlateTandCs}
      submitParams={{
        id,
        dealerId,
      }}
      onSubmitted={onDeleted}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Delete
        </div>
      )}
      renderModal={(modalProps) => (
        <Modal.Confirmation {...modalProps} header={"Delete: " + reference}>
          {reference + ": Delete Master Agreement Terms?"}
        </Modal.Confirmation>
      )}
    />
  );
};

export default RemoveBoilerPlateModal;
